module.exports = __webpack_public_path__ + "static/income_statement_2-6dec99fb24247579d98bef2adfde52c4.jpg";